'use strict';

var Router = require('base/Colido.Router');
var AppController = require('./controller');

/**
 * Main Router for the shared app
 *
 * @category   Router
 * @module     share
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var AppRouter = Router.extend({
    controller: new AppController(),

    appRoutes: {
        '*path/': 'removeTrailingSlash',
        '*notFound': 'notFound',
    },

    before: function(params, next) {
        return next();
    },
});

module.exports = AppRouter;